import { convertDate } from 'xpi-black-ui/Utils/helpers';

const typeDate = 'date';

export const normalizeFilters = (filters, filtersTypes) => {
  const filtersView = [];
  filtersTypes.forEach((filterType) => {
    const { type, name } = filterType;
    const isTypeDate = type === typeDate;

    if (filters[name] && filters[name].length > 0) {
      const options = filters[name]
        .map((filter) => {
          const item = isTypeDate ? convertDate(filter) : filter;
          const id = item.id || item.nome || item.name || filter;
          const value = item.nome || item.name || item;
          const label = item.nome || item.name || item;

          return ({ id, value, label, isSelected: false });
        })
        .sort((a, b) => (
          b.value > a.value ? -1: 1
        ));

      filtersView.push({
        ...filterType,
        name,
        options,
        placeholder: ' ',
        type: type || 'default',
      });
    }
    else {
      filtersView.push({
        ...filterType,
        options: [],
        placeholder: ' ',
        type: 'default',
      });
    }
  });

  return filtersView;
};

export default normalizeFilters;
